import { useQuery } from '@tanstack/react-query'
import React from 'react'

import { type UploadedFilesProperties } from './useMainQuery'
import { useMainQueryKey } from './useMainQueryKey'

export const useMainQueryData = () => {
  const queryKey = useMainQueryKey()

  const { data } = useQuery<UploadedFilesProperties>({
    enabled: false,
    queryKey,
  })

  return React.useMemo(() => data, [data])
}
